module.exports = __webpack_public_path__ + "static/media/31.b02ad137.mp3";